import { TModifiersAction, ModifiersActionTypes } from './modifiersActions';
import { IModifiersState } from './modifiersContext';

export const modifiersReducer = (state: IModifiersState, action: TModifiersAction): IModifiersState => {
	switch (action.type) {
		case ModifiersActionTypes.REFETCH_DATA:
			return {
				...state,
				needRefetchData: action.payload.needRefetchData,
			};
		case ModifiersActionTypes.SET_MODIFIERS_BY_CUSTOMER:
			return {
				...state,
				modifiersByCustomer: action.payload.modifiersByCustomer,
				typeOfModalWindow: action.payload.typeOfModalWindow,
				modifiersByRestaurant: { totalCount: 0, items: [] },
			};
		case ModifiersActionTypes.SET_MODIFIERS_BY_RESTAURANT:
			return {
				...state,
				modifiersByRestaurant: action.payload.modifiersByRestaurant,
				typeOfModalWindow: action.payload.typeOfModalWindow,
				modifiersByCustomer: { totalCount: 0, items: [] },
			};
		case ModifiersActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				currentPage: 1,
			};
		case ModifiersActionTypes.TOGGLE_REMEMBER_MY_CHOICE:
			return {
				...state,
				rememberMyChoice: action.payload.rememberMyChoice,
			};
		case ModifiersActionTypes.SET_FETCHED_CUSTOMERS:
			return {
				...state,
				fetchedCustomers: action.payload.fetchedCustomers,
			};
		case ModifiersActionTypes.SET_ID_CUSTOMER:
			return {
				...state,
				IDSelectedCustomer: action.payload.IDSelectedCustomer,
				modifiersByCustomer: action.payload.modifiersByCustomer,
				modifiersByRestaurant: action.payload.modifiersByRestaurant,
				IDSelectedRestaurant: null,
				IDSelectedModifierGroup: null,
				isDisabled: null,
				isRestricted: false,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_ID_RESTAURANT:
			return {
				...state,
				IDSelectedRestaurant: action.payload.IDSelectedRestaurant,
				isDisabled: action.payload.isDisabled,
				isRestricted: action.payload.isRestricted,
				IDSelectedModifierGroup: null,
				currentPage: 1,
			};
		case ModifiersActionTypes.TOGGLE_IS_DISABLED: {
			return {
				...state,
				isDisabled: action.payload.isDisabled,
				currentPage: 1,
			};
		}
		case ModifiersActionTypes.TOGGLE_IS_RESTRICTED: {
			return {
				...state,
				isRestricted: !state.isRestricted,
				currentPage: 1,
			};
		}
		case ModifiersActionTypes.SET_ID_MODIFIER_GROUP:
			return {
				...state,
				IDSelectedModifierGroup: action.payload.IDSelectedModifierGroup,
				currentPage: 1,
			};
		case ModifiersActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				searchString: '',
				IDSelectedRestaurant: null,
				IDSelectedModifierGroup: null,
				isDisabled: null,
				isRestricted: false,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				currentPage: 1,
			};
		case ModifiersActionTypes.SET_COUNT_OF_ITEMS:
			return {
				...state,
				countOfItems: action.payload.countOfItems,
				currentPage: 1,
			};
		case ModifiersActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
			};
		case ModifiersActionTypes.SET_ID_FOR_DELETION:
			return {
				...state,
				IDForDeletion: action.payload.IDForDeletion,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.SET_ID_FOR_ASSIGN_RESTAURANTS:
			return {
				...state,
				IDForAssignRestaurants: action.payload.IDForAssignRestaurants,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.SET_ID_FOR_EDIT_MOD_GROUP_TEMPLATE:
			return {
				...state,
				IDForEditModGroupTemplate: action.payload.IDForEditModGroupTemplate,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case ModifiersActionTypes.SET_FILTERS_FROM_QUERY_STRING:
			return {
				...state,
				...action.payload.filters,
				isInitializedSelectCustomerModal: true,
			};
		default:
			return state;
	}
};
